import {WidgetCheckboxV0NodeDto} from './models/widget-checkbox-v0-node.dto';
import {WidgetCheckboxV0ResponseDto} from './models/widget-checkbox-v0-response.dto';
import {WidgetCheckboxV0Mode} from './models/widget-checkbox-v0-mode';

export class WidgetCheckboxV0Utils {

  static queryResponseToCheckBoxNodeWithValue(response: unknown[], mapping: unknown, value: string[]): WidgetCheckboxV0NodeDto[] {
    const checkBoxResponse = WidgetCheckboxV0Utils.queryResponseToCheckBoxResponse(response, mapping);
    const checkboxNode = WidgetCheckboxV0Utils.checkBoxResponseToCheckboxNode(checkBoxResponse);
    const checkboxNodeWithValue = WidgetCheckboxV0Utils.checkBoxNodeCheckValue(checkboxNode, value);
    return checkboxNodeWithValue;
  }

  static queryResponseToCheckBoxResponse(queryResponse: unknown[], mapping: unknown): WidgetCheckboxV0ResponseDto[] {
    const keys = Object.keys(mapping);
    const response: WidgetCheckboxV0ResponseDto[] = [];
    queryResponse.forEach((q: unknown) => {
      const obj = {};
      keys.forEach((outputKey: string) => {
        obj[outputKey] = q[mapping[outputKey]];
      });
      response.push(obj as WidgetCheckboxV0ResponseDto);
    });

    return response;
  }

  static checkBoxResponseToCheckboxNode(checkbox: WidgetCheckboxV0ResponseDto[]): WidgetCheckboxV0NodeDto[] {
    const categories: string[] = [];
    checkbox.forEach((c: WidgetCheckboxV0ResponseDto) => {
      if (c.category && !categories.includes(c.category)) {
        categories.push(c.category);
      }
    });
    const response: WidgetCheckboxV0NodeDto[] = [];
    categories.forEach((category) => {
      const children = checkbox.filter((cb) => cb.category === category);
      response.push({
        uuid: null,
        parentId: null,
        id: category,
        label: category,
        help: null,
        checked: false,
        children: children.map(c => {
          return {
            parentId: c.id,
            uuid: c.uuid,
            id: c.uuid,
            label: c.label,
            help: c.help,
            checked: c.checked ? c.checked : false
          } as WidgetCheckboxV0NodeDto;
        })
      });
    });
    return response;
  }

  static checkBoxNodeCheckValue(checkboxNode: WidgetCheckboxV0NodeDto[], value: string[]): WidgetCheckboxV0NodeDto[] {
    const response: WidgetCheckboxV0NodeDto[] = JSON.parse(JSON.stringify(checkboxNode));
    if (value?.length > 0 && response?.length > 0) {
      response.forEach((node: WidgetCheckboxV0NodeDto) => {
        node.checked = value.includes(node.uuid);
        if (node.children) {
          node.children = WidgetCheckboxV0Utils.checkBoxNodeCheckValue(node.children, value);
        }
      });
    }
    return response;
  }

  static checkboxNodeToValue(checkboxNode: WidgetCheckboxV0NodeDto[]): string[] {
    const response: string[] = [];
    if (checkboxNode?.length > 0) {
      checkboxNode.forEach((node) => {
          if (node.checked && node.uuid) {
            response.push(node.uuid);
          }

          if (node.children?.length > 0) {
            const childrenUUID = WidgetCheckboxV0Utils.checkboxNodeToValue(node.children);
            if (childrenUUID.length > 0) {
              response.push(...childrenUUID);
            }
          }
        }
      );
    }
    return response;
  }

  static getOnlyChildren(checkboxNode: WidgetCheckboxV0NodeDto[]) {
    const children: WidgetCheckboxV0NodeDto[] = [];
    if (checkboxNode?.length > 0) {
      checkboxNode.forEach((node: WidgetCheckboxV0NodeDto) => {
        if (node.children?.length > 0) {
          children.push(...node.children);
        }
      });
    }
    return children;
  }


  static getWidgetCheckboxV0Mode(isFlat: boolean, isGroup: boolean, hasChildren: boolean): WidgetCheckboxV0Mode {

    switch (true) {
      case hasChildren:
        return WidgetCheckboxV0Mode.CHILDREN;
      case isGroup:
        return WidgetCheckboxV0Mode.SELECT_CATEGORY;
      case isFlat:
        return WidgetCheckboxV0Mode.CHECKBOX;
      default:
        return WidgetCheckboxV0Mode.TREE;
    }

    // if (hasChildren) {
    //   return WidgetCheckboxV0Mode.CHILDREN;
    // }
    // if (isGroup) {
    //   return WidgetCheckboxV0Mode.SELECT_CATEGORY;
    // } else {
    //   if (isFlat) {
    //     return WidgetCheckboxV0Mode.CHECKBOX;
    //   }
    //   return WidgetCheckboxV0Mode.TREE;
    // }
  }

  static getWidgetCheckboxV0NodeDtoUUID(editorData: WidgetCheckboxV0NodeDto[]): string[] {
    const uuids: string[] = [];
    if (editorData) {
      editorData?.forEach((node: WidgetCheckboxV0NodeDto) => {
        if (node?.uuid) {
          uuids.push(node?.uuid);
        }
        const children = WidgetCheckboxV0Utils.getWidgetCheckboxV0NodeDtoUUID(node.children);
        if (children?.length > 0) {
          uuids.push(...children);
        }
      });
    }
    return uuids;
  }

  static getValidValue(value: string[], validValues: string[]): string[] {
    const validValue = [];
    if (value && value?.length > 0 && validValues?.length > 0) {
      value.forEach((currentSavedValue: string) => {
        if (validValues.includes(currentSavedValue)) {
          validValue.push(currentSavedValue);
        }
      });
    }
    return validValue;
  }

  static getNumSelectedOptions(checkbox: WidgetCheckboxV0NodeDto[]) {
    let response = 0;
    for (let i = 0; i < checkbox.length; i++) {
      response += checkbox[i].children ? checkbox[i].children.filter(f => f.checked).length : 0;
    }
    return response;
  }

  static getNumOptions(checkbox: WidgetCheckboxV0NodeDto[]) {
    let response = 0;
    for (let i = 0; i < checkbox.length; i++) {
      response += checkbox[i].children ? checkbox[i].children.length : 0;
    }
    return response;
  }
}
